import { AbstractFilterHandler } from '../AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

export class PhaseFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        // console.log('PhaseFilterHandler->handle');

        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        if (filterOptions.phase !== undefined && filterOptions.phase.id !== 0) {
            // console.log('PhaseFilterHandler->handle phase:', filterOptions.phase);

            res = arr.filter((el: FilterData) => {
                el.lessons = el.lessons.filter((lesson) => {
                    return lesson.phases.findIndex((lessonPhase) => lessonPhase.id === filterOptions.phase.id) !== -1;
                });

                return el;
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
